/* eslint-disable */
const storagePrefix = "project_hub_";
const SESSION_IMPERSONATE_KEY = `${storagePrefix}session_impersonation`;

const storage = {
  getToken: (): string | null => {
    if (typeof window !== "undefined") {
      const sessionTok = window.sessionStorage.getItem(SESSION_IMPERSONATE_KEY);
      if (sessionTok) {
        try {
          return JSON.parse(sessionTok) as string;
        } catch {
          return sessionTok;
        }
      }

      const token = window.localStorage.getItem(`${storagePrefix}token`);
      if (token) {
        try {
          return JSON.parse(token) as string;
        } catch {
          return token;
        }
      }
    }
    return null;
  },
  setToken: (token: string) => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(
        `${storagePrefix}token`,
        JSON.stringify(token)
      );
    }
  },
  clearToken: () => {
    if (typeof window !== "undefined") {
      window.localStorage.removeItem(`${storagePrefix}token`);
    }
  },

  clearAll: () => {
    if (typeof window !== "undefined") {
      // Local storage
      window.localStorage.removeItem(`${storagePrefix}token`);
      window.localStorage.removeItem(`${storagePrefix}original`);
  
      // Session storage
      window.sessionStorage.removeItem(SESSION_IMPERSONATE_KEY);
  
      // (Optional but recommended)
      window.localStorage.removeItem(`${storagePrefix}user`);
      window.localStorage.removeItem(`${storagePrefix}permissions`);
    }
  },
  

  getOriginalToken: (): string | null => {
    if (typeof window === "undefined") return null;
    const tok = window.localStorage.getItem(`${storagePrefix}original`);
    return tok ? JSON.parse(tok) : null;
  },
  setOriginalToken: (token: string) => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(
        `${storagePrefix}original`,
        JSON.stringify(token)
      );
    }
  },
  clearOriginalToken: () => {
    if (typeof window !== "undefined") {
      window.localStorage.removeItem(`${storagePrefix}original`);
    }
  },

  setSessionImpersonationToken: (token: string) => {
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem(
        SESSION_IMPERSONATE_KEY,
        JSON.stringify(token)
      );
    }
  },
  getSessionImpersonationToken: (): string | null => {
    if (typeof window === "undefined") return null;
    const t = window.sessionStorage.getItem(SESSION_IMPERSONATE_KEY);
    return t ? JSON.parse(t) : null;
  },
  clearSessionImpersonationToken: () => {
    if (typeof window !== "undefined") {
      window.sessionStorage.removeItem(SESSION_IMPERSONATE_KEY);
    }
  },
};

export default storage;
